export const StarIcon = <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_439_142)">
        <path d="M8.66667 1.33325L10.7267 5.50659L15.3333 6.17992L12 9.42659L12.7867 14.0133L8.66667 11.8466L4.54667 14.0133L5.33333 9.42659L2 6.17992L6.60667 5.50659L8.66667 1.33325Z" fill="#EA6B26" stroke="#EA6B26" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_439_142">
            <rect width="16" height="16" fill="white" transform="translate(0.666992)"/>
        </clipPath>
    </defs>
</svg>
